const NBSP_SYMBOL = String.fromCharCode(160)
export const NBSP_REGEX = new RegExp(NBSP_SYMBOL, 'g')

export const CURRENCIES_ENFORCE_CODE_FOR = ['MXN']
